import { ErrorResponse } from '~shared/modules/error-handler';
import { Hub } from '~app/modules/custom-hub/models';

export interface HubState {
  hub: Hub;
  loading: boolean;
  error: ErrorResponse;
}

export const HubInitialState: HubState = {
  hub: {
    slug: '',
    title: '',
    introText: '',
    categories: [],
    seoContent: {
      introContent: '',
      active: true,
      advisoryContentTitle: '',
      advisoryContentDescription: '',
      otherContentJSON: '[]',
    }
  },
  loading: false,
  error: null,
};
